import { useEffect, useState } from 'react';

import { Checkbox, Badge, Button } from '@mui/material';

import PropTypes from 'prop-types';

import _ from 'lodash';

import getSlug from 'speakingurl';

import { useRouter } from 'next/router';

const CategoryFilterButton = (props) => {

    const { children, onChange, roomTypes } = props;
    const [openModal, setOpenModel] = useState(false);
    const [badgeCount, setCategoriesBadgeCount] = useState(0);
    const [selectedCategories, setSelectedCategories] = useState(null);
    const router = useRouter();
    const { query } = router;

    useEffect(() => {
        getCategoriesFromQuery();
        checkBadgeCount();
    }, [query]);

    const onFilterClick = () => {
        setOpenModel(true);
    };

    const onModalClose = () => {
        setOpenModel(false);
    };

    const checkBadgeCount = () => {
        let count = 0;
        if (_.get(query, 'category')) {
            if (typeof _.get(query, 'category') === 'string') {
                count += 1;
            } else {
                const categoryCount = _.size(_.get(query, 'category'));
                count += categoryCount;
            }
        }
        setCategoriesBadgeCount(count);
    };

    const getCategoriesFromQuery = () => {
        const categoryParams = _.get(query, 'category');
        const uniqueCategories = _.uniq(
            _.map(roomTypes, (roomType) => `${_.trim(_.get(roomType, 'category'))}`),
        );
        if (categoryParams) {
            const options = [];
            _.forEach(uniqueCategories, (category) => {
                if (typeof categoryParams === 'string') {
                    if (getSlug(_.lowerCase(category)) === categoryParams) {
                        options.push(categoryParams);
                    }
                } else {
                    _.filter(categoryParams, (cat) => {
                        if (getSlug(_.lowerCase(category)) === cat) {
                            options.push(cat);
                        }
                    });
                }
            });
            setSelectedCategories(options);
        } else {
            setSelectedCategories(null);
        }
    };

    const onCategorySelect = (value) => {
        let categoryValues = null;
        if (_.includes(selectedCategories, value) && !_.isEmpty(selectedCategories)) {
            let newSelectedCategories = _.cloneDeep(selectedCategories);
            newSelectedCategories = _.remove(newSelectedCategories, (cat) => cat !== value);
            setSelectedCategories(newSelectedCategories);
            categoryValues = newSelectedCategories;
        } else if (selectedCategories && !_.isEmpty(selectedCategories)) {
            if (typeof selectedCategories === 'string') {
                setSelectedCategories([selectedCategories, value]);
                categoryValues = [selectedCategories, value];
            } else {
                const catOptions = _.cloneDeep(selectedCategories);
                catOptions.push(value);
                setSelectedCategories(catOptions);
                categoryValues = catOptions;
            }
        } else {
            setSelectedCategories([value]);
            categoryValues = [value];
        }
        if (onChange) {
            onChange(categoryValues);
        }
    };

    const renderCategoryData = () => {
        const uniqueCategories = _.uniq(
            _.map(roomTypes, (roomType) => `${_.trim(_.get(roomType, 'category'))}`),
        );

        return _.map(uniqueCategories, (category, index) => {
            return (
                <div className='category-filter-checkbox-line-item' key={index} onClick={() => onCategorySelect(getSlug(category))}>
                    <div className='category-filter-checkbox-wrapper'>
                        <Checkbox
                            checked={_.includes(selectedCategories, getSlug(category))}
                            disableRipple
                        />
                    </div>
                    <h6>{category}</h6>
                </div>
            );
        });
    };

    return (
        <div className='category-filter-container'>
            <Button
                id="category-filter"
                badge={badgeCount > 0 ? badgeCount : 0}
                className={badgeCount > 0 ? 'category-filter-badge' : 'category-filter-no-badge'}
                onClick={onFilterClick}
            >
                <Badge badgeContent={badgeCount}>
                    {children}
                </Badge>
            </Button>
            {openModal && (
                <div>
                    <div className='category-filter-overlay' onClick={onModalClose} />
                    <div className='category-filter-modal-container'>{renderCategoryData()}</div>
                </div>
            )}
        </div>
    );
};

CategoryFilterButton.propTypes = {
    children: PropTypes.string,
    roomTypes: PropTypes.object,

    onChange: PropTypes.func,
};

export default CategoryFilterButton;

